module.exports = __webpack_public_path__ + "img/travel-calendar-1.1db44f64.svg";